export const userKeys = {
  current: () => ['user'] as const,
  currentScoped: (params: {
    sessionScopeKey: string
    currentUserId?: string
    impersonatedUserId?: string
  }) =>
    [
      'user',
      params.sessionScopeKey,
      params.currentUserId ?? null,
      params.impersonatedUserId ?? null,
    ] as const,
  light: (id: string | undefined) => ['userLight', id] as const,
  session: (id: string | undefined) => ['userSessionByUser', id],
}
